import React from "react";
import Modal from "./Components/Modal";
import { X } from 'lucide-react';

interface ConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
  content?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ show, onHide, onConfirm, title, content }) => {
  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={onHide}
        id="confirmModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-[calc(100vw-2rem)] max-w-[25rem] mx-4 bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Body className="max-h-[calc(100vh-4rem)] overflow-y-auto px-4 py-6 sm:px-6 sm:py-8">
          <div className="float-right">
            <button
              data-modal-close="confirmModal"
              className="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500"
            >
              <X className="size-5" onClick={onHide} />
            </button>
          </div>
          <div className="mt-5 text-center">
            <p className="text-start font-bold text-[14px] md:text-[15px] mb-3 sm:mb-6">{title}</p>
            <p className="text-start">{content}</p>
            <div className="flex justify-end gap-2 mt-5 sm:mt-10">
              <button
                type="reset"
                className="bg-white text-slate-500 btn hover:text-slate-500 hover:bg-slate-100 focus:text-slate-500 focus:bg-slate-100 active:text-slate-500 active:bg-slate-100 dark:bg-zink-600 dark:hover:bg-slate-500/10 dark:focus:bg-slate-500/10 dark:active:bg-slate-500/10"
                onClick={(e) => { e.preventDefault(); onHide(); }}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="confirmAction"
                data-modal-close="confirmModal"
                className="text-white bg-custom-500 border-custom-500 btn hover:text-white hover:custom-500 hover:border-custom-600 focus:text-white focus:bg-custom-500 focus:border-custom-500 focus:ring focus:ring-red-100 active:text-white active:bg-custom-500 active:border-custom-500 active:ring active:ring-red-100 dark:ring-custom-400/20"
                onClick={(e) => { e.preventDefault(); onConfirm(); }}
              >
                Yes, Proceed
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmModal;